import { useSelectAppMode } from 'app/store/general/selectors';
import { usePortfolioSelectedSymbols } from 'portfolio/store/hooks';
import { AppMode } from 'app/store/general/AppMode';
import { portfolioMessage } from 'portfolio/components/SelectionStatus';

const WidgetTitle = 'Index Events Widget';

const meetsRequirements = { meetsRequirements: true };
const standalone = {
    meetsRequirements: false,
    alert: `Select at least one symbol to use the ${WidgetTitle}`,
};
const newport = {
    meetsRequirements: false,
    alert: portfolioMessage(WidgetTitle),
};

export function useIndexEventsPortfolioRequirements(): {
    meetsRequirements: boolean;
    alert?: string;
} {
    const appMode = useSelectAppMode();
    const symbols = usePortfolioSelectedSymbols();

    if (symbols.length > 0) {
        return meetsRequirements;
    }
    return appMode === AppMode.STANDALONE ? standalone : newport;
}
